import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SydSelect from '../../../../../commonDesign/SydSelect'

// Compact select rendered above TrendDetailTable when there's more
// than one active series. The detail table only shows one series at
// a time (per the multi-series spec: don't try to combine without
// feedback), so this picker is how the user switches which series's
// numbers are listed.

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 10px 6px',
    fontSize: 12,
    color: 'var(--color-neutral-700, #555)',
    borderTop: '1px solid var(--opal-border-default, #eee)'
  },
  label: {
    fontSize: 11,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    color: 'var(--color-neutral-500, #888)'
  }
}))

export default function DetailSeriesPicker ({ items, value, onChange }) {
  const classes = useStyles()
  const options = useMemo(
    () => (items || []).map(i => ({ value: i.id, label: i.label })),
    [items]
  )
  if (!options.length) return null
  return (
    <div className={classes.row}>
      <span className={classes.label}>Showing</span>
      <SydSelect
        options={options}
        value={value || options[0].value}
        onChange={(e) => onChange(e.target.value)}
        size='xs'
        minWidth='180px'
      />
    </div>
  )
}

DetailSeriesPicker.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
}
